
/*
      ##    #######   ##     ##  ########   ########   ##    ##   
      ##   ##     ##  ##     ##  ##         ##     ##   ##  ##    
      ##   ##     ##  ##     ##  ##         ##     ##    ####     
      ##   ##     ##  ##     ##  ######     ########      ##      
##    ##   ##  ## ##  ##     ##  ##         ##   ##       ##      
##    ##   ##    ##   ##     ##  ##         ##    ##      ##      
 ######     ##### ##   #######   ########   ##     ##     ##      
*/

function checkClientEntite(field, rules, i, options){
	if (field.val() == "") {
     	// this allows the use of i18 for the error msgs
     	console.log('test');
    	// return options.allrules.validate2fields.alertText;
	}
}

function getGeocode( form, componentForm, field ){

	var autocomplete, places;

	var southWest = new google.maps.LatLng(48.856556,2.350146);
	var northEast = new google.maps.LatLng(48.856556,2.350146);
	var hyderabadBounds = new google.maps.LatLngBounds( southWest, northEast );

	var form = jQuery(form);

	fieldId = form.find(field).attr('id');

	autocomplete = new google.maps.places.Autocomplete(
		document.getElementById(fieldId), {
			bounds : hyderabadBounds
	});
	document.getElementById(fieldId).placeholder = '';

	autocomplete.addListener('place_changed', onPlaceChanged);

	function onPlaceChanged() {
		var place = autocomplete.getPlace();
		address   = [];

		console.log( place.address_components );

		for (var component in componentForm) {
			var componentId = form.find(componentForm[component]).attr('id');
			document.getElementById(componentId).value = '';
			document.getElementById(componentId).disabled = false;
		}

		for (var i = 0; i < place.address_components.length; i++) {
			var addressType = place.address_components[i].types[0];
			if ( componentForm[addressType] ) {
				var val = place.address_components[i]['long_name'];
				if( addressType !== "route" ) address = [];
				address.push(val);
				var componentId = form.find(componentForm[addressType]).attr('id');
				if( addressType == "administrative_area_level_2" ){
					$("option", "#"+componentId).prop('selected',false);
					$("#"+componentId).trigger('change');
					$("option", "#"+componentId).each(function(){
						if( $(this).html() == address ){
							$(this).prop('selected',true);
							$("#"+componentId).trigger('change');
						}
					});
				}else{
					document.getElementById(componentId).value = address.join(' ');
				}
			}
		}
		document.getElementById(fieldId).placeholder = '';
	}

}

function formatNumber(number){
	var formattedNumber = number+"";
	return formattedNumber.replace(/(\d{3})/g, '$1 ').replace(/(^\s+|\s+$)/,'');
}

function animateNumber( element, increase ){
	var interval = 5;
	var start    = increase ? element.data('reduit') : element.data('prix');
	var to       = increase ? element.data('prix') : element.data('reduit'); 
	var count    = 1;
	if( increase ){
		for(var i = start; i < to; i = i + 200){
			(function(i){
				setTimeout(function(){
					element.html(formatNumber(i));
				},interval * count);
			})(i);
			count++;
			setTimeout(function(){
				element.html(formatNumber(to));
			},interval * count);
		}
	}else{
		for(var i = start; i > to; i = i - 200){
			(function(i){
				setTimeout(function(){
					element.html(formatNumber(i));
				},interval * count);
			})(i);
			count++;
			setTimeout(function(){
				element.html(formatNumber(to));
			},interval * count);
			
		}
	}
}

function montantReservation(){

	var data        = $("#_f_reservation_reduit").val() == 1 ? "reduit" : "prix";
	var isCuisine   = $("#_f_reservation_cuisine").val();
	var cuisine     = isCuisine == 1 ? parseInt($(".ep-client-reservation__price-detail--cuisine em").html().replace(/\s/g, "")) : 0;

	if( isCuisine == 1 ){
		$(".ep-client-reservation__price-detail--cuisine").removeClass('ep-client-reservation__price-detail--cuisine--none');
	}else{
		$(".ep-client-reservation__price-detail--cuisine").addClass('ep-client-reservation__price-detail--cuisine--none');
	}

	$('.ep-client-reservation__price-detail li:not(.ep-client-reservation__price-detail--cuisine) em').each(function(){
		var price = parseInt( $(this).data(data) );
		if( $(this).closest('.ep-client-reservation__price-detail--total').length > 0 ){
			var price = parseInt( $(this).data(data) ) + parseInt( cuisine );
		}
		$(this)
		.prop('number', $(this).html().replace(/\s/g, ""))
		.animateNumber(
		{
			number: price,
			numberStep: function(now, tween) {
				var floored_number = Math.floor(now),
				target = $(tween.elem);
				number = floored_number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
				target.html(number);

				if( target.closest('.ep-client-reservation__price-detail--total') ){
					$("#_f_reservation_vente").val( number );
				}
			}
		},
			700
		);
	});

}

$(document).ready(function() {

	function getUrlVars() {
		var vars = {};
		var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
			vars[key] = value;
		});
		return vars;
	}

	if( getUrlVars().modal ){
		$.magnificPopup.open({
		    items: {
		        src: '#'+getUrlVars().modal 
		    },
		    type: 'inline'
		});
	}

	$('.ep-client-reservation__price-detail li span:last-of-type em').each(function(){
		//$(this).numberAnimate();
	});

	var comma_separator_number_step = $.animateNumber.numberStepFactories.separator(' ');

	$("#_f_reservation_reduit").on('change', function(){
		montantReservation();
	});

	$("#_f_reservation_cuisine").on('change', function(){
		montantReservation();
	});

	$('select[name="js-lot-hidden"]').change(function(e){

		val = $(this).val();

		$('.table-lots--prescripteur tbody tr').show();
		if( val != "" ){
			$('.table-lots--prescripteur tbody tr:not(.table-lots__'+val+'):not(.table_lots__type)').hide();			
		}

		$('.table-lots--prescripteur tbody tr.table_lots__type').each(function(){
			if ( $('.table-lots--prescripteur tbody tr.'+ $(this).data('type')+':visible').length === 0 ){
				$(this).hide();
			}
		});

		// $('.table-lots--prescripteur tbody tr.table_lots__type').each(function(){
		// 	console.log( $('.table-lots--prescripteur tbody tr.table-lots__'+val+':visible').length );
		// 	if ( $('.table-lots--prescripteur tbody tr.table-lots__'+val+':visible').length === 0 ){
		// 		$(this).hide();
		// 	}
		// });

	});

	$('.zoom').magnificPopup({
		type: 'image',
		tLoading: 'Loading image #%curr%...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
		}		
	});

	$("#formMeet").submit(function(){
		if($("#formMeet").validationEngine('validate')){
			var form   = $(this);
			var fields = form.find('.search__fields').hide();
			var data   = form.serialize() + '&act=meeting';
			var div    = form.find('.form-retour').show().removeClass('form-error').empty().html('Envoi en cours...');
			
			$.ajax({
				type    : "POST",
				data    : data,
				url     : "/meeting/",
				success : function(retour) {
			        div.empty().html(retour);
			        setTimeout(function(){
						$.magnificPopup.close();
					}, 2000);
					setTimeout(function(){
						fields.show();
						div.empty().hide();
					}, 2500);
				}
			});

		}
		return false;
	});

	$('.fidelity-detail').magnificPopup({
		type: 'inline',
		preloader: false,
		focus: "#name"
	});

	$('.challenge-win--btn').click(function(e){
		e.preventDefault();
		$(this).toggleClass('active').next('div').slideToggle();
	});

	var owl = $('.owl-progress');
	owl.owlCarousel({
	    items:1,
	    margin:3,
	    touchDrag:false,
	    pullDrag:false,
	    mouseDrag:false,
	    nav:true,
	    navText:['',''],
	    responsive:{
	        768:{
	            items:3
	        }
	    }
	});

	$(".owl-progress .item").each(function(key, value){
		if( $(this).find('.fidelity-step--percent').data('width') > 0 && $(this).find('.fidelity-step--percent').data('width') < 100 ){
			owl.trigger("to.owl.carousel", [(key-1),0,true]);
		}
	});

	$(".js-toggle-challenge").click(function(e){
		e.preventDefault();
		$(this).prev('div').toggleClass('hidden');
		$.fn.matchHeight._update();
	});

	$.datepicker.setDefaults({
		// dateFormat: "dd/mm/yy",
		// altFormat: "yy-mm-dd",
		dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
		monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
		monthNamesShort: ["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"],
	});

	initDatepicker = function(){

		$('.datepicker:not(hasDatepicker)').each(function() {

			var element = $(this).prev('input');
			var max     = $(this).attr("max");
			var min     = $(this).attr("min");
			var noday   = $(this).attr("noday");

			if( noday ){
				$.datepicker.setDefaults({
					dateFormat: "mm/yy",
					altFormat: "yy-mm",
					changeMonth: true,
					changeYear: true
				});
			}else{
				$.datepicker.setDefaults({
					dateFormat: "dd/mm/yy",
					altFormat: "yy-mm-dd"
				});				
			}

			$(this).datepicker({
				altField: element,
				onClose: function( selectedDate, inst ) {
					if(max) $("#"+max).datepicker("option", "minDate", selectedDate);
					if(min) $("#"+min).datepicker("option", "maxDate", selectedDate);
				}
			});
			
			if(max) $(this).datepicker("option", "maxDate", max );
			if(min) $(this).datepicker("option", "minDate", min );		

		});

	}

	submitForm = function( form, action ){

        var divRetour = $(".ep-form__retour", form).html('<p>traitement en cours...</p>');
        var url       = form.attr('action');

		$('.ep-form__actions', form).addClass('ep-form__actions--no-action');

        formData = new FormData();
        formParams = form.serializeArray();
        formData.append("act", action);

        $.each(form.find('input[type="file"]'), function(i, tag) {
			$.each($(tag)[0].files, function(i, file) {
				formData.append(tag.name, file);
			});
		});

		$.each(formParams, function(i, val) {
			formData.append(val.name, val.value);
		});

        $.ajax({
            type    : "POST",
            data    : formData,
            url     : url,
            processData: false,
			contentType: false,
            success : function(retour) {
            	try {
					retour = JSON.parse(retour);
					if( retour.error ){
						
						divRetour.empty().append('<p class="ep-form__retour--error">'+retour.error+'</p>');
						$('.ep-form__actions').removeClass('ep-form__actions--no-action');
						setTimeout(function(){ 
							divRetour.empty();
						}, 3000);

					}else if( retour.redirect ){

						divRetour.empty().html('<p class="ep-form__retour--valid">'+retour.message+'</p>');
						setTimeout(function(){
							window.location = retour.redirect;
						}, 2000);

					}else if( retour.target ){

						divRetour.empty().html('<p class="ep-form__retour--valid">'+retour.message+'</p>');
						insertViaAjax( retour.url, retour.target );

					}else{

						// message de retour
						divRetour.empty().html('<p class="ep-form__retour--valid">'+retour.message+'</p>');
						
						setTimeout(function(){ 
							divRetour.empty();
							$('.ep-form__actions').removeClass('ep-form__actions--no-action');
						}, 4000);

						// rechargement de la page
						if( retour.reload ){
							setTimeout(function(){ 
								location.reload();
							}, retour.reload);
						}

					}
				}catch(e){

                	divRetour.empty().append(retour);

                }
            }
        });
	}

	var select2Ajax = function( element ){

		var split = element.data('refresh').split("|");


		$.each( split, function(index, tab){
			var s             = tab.split("__");
			var selectRefresh = $("#"+s[0]);

			// console.log( selectRefresh.attr('id') );

			// if( ! selectRefresh.attr('data-disabled') ){

				var search        = s[1];
				var selected      = selectRefresh.prev('input').val();
				var data          = "value="+element.val()+"&search="+search+"&selected="+selected;
				$.ajax({
					type: "POST",
					data: data,
					url: '/prescripteur.php?content=select2',
					success: function (retour) {
						try {
							retour = JSON.parse(retour);
							if (retour.error) {
								alert(retour.error);
							} else {
								if (retour.option) {
									selectRefresh.html('').select2('destroy');
									if (retour.option.length > 1) {
										selectRefresh.attr('data-placeholder', selectRefresh.attr('data-placeholder-refreshed'))
									} else {
										if (selectRefresh.attr('data-placeholder-noresult')) {
											selectRefresh.attr('data-placeholder', selectRefresh.attr('data-placeholder-noresult'))
										} else {
											selectRefresh.attr('data-placeholder', selectRefresh.attr('data-placeholder-initial'))
										}
									}
									selectRefresh.select2({
										separator: ';',
										data: retour.option
									});
									selectRefresh.trigger('change');
								}
							}
						} catch (e) {
							alert(retour);
						}
					}
				});

			// }
		});

		return false;

	}

	var select2Init = function(){

		$("select.select2").each(function(){

			if( ! $(this).hasClass('select2-hidden-accessible') ){

				disabled = ( $(this).data('disabled') ) ? true : false;
				$(this).select2({
					language: "fr",
					minimumResultsForSearch: 10,
					disabled: disabled,
					separator: ';'
				}).change(function(){
					if( $(this).attr('multiple') ){
						if( $(this).val() !== null ){
							$(this).prev('input').val( $(this).val().join(';') );
						}else{
							$(this).prev('input').val("");
						}
					}else{
						$(this).prev('input').val( $(this).val() );
					}
				});

				if( $(this).attr('data-refresh') ){
					// if( $(this).val() != "" && $(this).val != 0 && ! $(this).attr('data-disabled') ){
					if( $(this).val() != "" && $(this).val != 0 ){
						select2Ajax( $(this) );
					}
					$(this).on('select2:select select2:unselect', function(){
						select2Ajax( $(this) );
					});
				}

			}

		});

		setTimeout(function(){
	        $.fn.matchHeight._beforeUpdate = function(event, groups) {
				$('[data-mh]').css('height', '');
			}
			$.fn.matchHeight._update();
		}, 500);

	}

	initForm = function(){

		initDatepicker();
		select2Init();

		$('input.js-field-change').change(function(){
			$(this).closest('.ep-form-field').nextAll(".ep-form-field--change").toggleClass('ep-form-field--hidden');
		});

		$(".select2-js-client").each(function() {
			$(this).select2({
				language:"fr",
				placeholder : 'sélectionnez un client',
				allowClear: true,
				dropdownCssClass:"select-client-dropdown",
				minimumResultsForSearch: 10
			});

			$(this).on('select2:select', function(e){
				var val = e.params.data.id;
				if( parseInt(val) === 0 ){
					$('.ep-form-field--change').removeClass('ep-form-field--hidden');
				}else{
					$('.ep-form-field--change').addClass('ep-form-field--hidden');
				}
			});
		});

		$('.ep-select-multiple').each(function(){
			var placeholder = $(this).data('placeholder');
			var selectAll   = $(this).data('selectall');
			$(this).multipleSelect({
				filter:               true,
				placeholder:          placeholder,
				selectAllText:        "Tout sélectionner",
				allSelected:          selectAll,
				selectAllDelimiter:   ['',''],
				minimumCountSelected: 1,
				countSelected:        "# sur % sélectionnés",
				maxHeight:            300
			});
		});

		$(".ep-form").validationEngine({ 
			scroll: false,
			showPrompts: false,
			onFieldFailure: function(_input){
				_input.closest('.ep-form-field').addClass('error');
			},
			onFieldSuccess: function(_input){
				_input.closest('.ep-form-field').removeClass('error');
			}
		});

		$('.button-delete').on('click', function(){
			$('.ep-form-field, .ep-form__actions__submit, .button-delete').hide();
			submitForm( $(this).closest(".ep-form"), 'delete' );
		});

		$('.ep-form').submit(function(){
			if( $(this).find('form').attr('id') == 'ep-form--filter' ){

			}else if( $(this).validationEngine('validate') ){
				submitForm( $(this), 'envoi' );
				return false;
			}
		});

		$('.ep-form--stats').unbind('submit').submit(function(){
			if( $(this).validationEngine('validate') ){
				submitFormStats( $(this), $(this).data('charts') );
	        }
			return false;
		});

		if( $('.edit-field-adresse').length > 0 ){
			var componentForm = {
				'street_number':               '.edit-field-adresse',
				'route':                       '.edit-field-adresse',
				'locality':                    '.edit-field-ville',
				'country':                     '.edit-field-pays',
				'postal_code':                 '.edit-field-code-postal',
				'administrative_area_level_2': '.edit-field-departement'
			};
			getGeocode('.ep-form', componentForm, '.edit-field-adresse' );
		}

		$('input[type="checkbox"][name="~prescripteur_independant"]').on('change', function(){
			select = $('select[name="~prescripteur_plateforme"]');
			if( $(this).prop('checked') ){
				select.prop('disabled','disabled');
				select.val(null).trigger("change");
			}else{
				select.prop('disabled','');
			}
		});

	}

	initPage = function(){
		initForm();
	}
	initPage();

/*
########      ###      ######    ##     ##  ########    #######      ###     ########   ########   
##     ##    ## ##    ##    ##   ##     ##  ##     ##  ##     ##    ## ##    ##     ##  ##     ##  
##     ##   ##   ##   ##         ##     ##  ##     ##  ##     ##   ##   ##   ##     ##  ##     ##  
##     ##  ##     ##   ######    #########  ########   ##     ##  ##     ##  ########   ##     ##  
##     ##  #########        ##   ##     ##  ##     ##  ##     ##  #########  ##   ##    ##     ##  
##     ##  ##     ##  ##    ##   ##     ##  ##     ##  ##     ##  ##     ##  ##    ##   ##     ##  
########   ##     ##   ######    ##     ##  ########    #######   ##     ##  ##     ##  ########   
*/
/*
 ######    ##         ####  ########   ##    ##   ########   
##    ##   ##          ##   ##         ###   ##      ##      
##         ##          ##   ##         ####  ##      ##      
##         ##          ##   ######     ## ## ##      ##      
##         ##          ##   ##         ##  ####      ##      
##    ##   ##          ##   ##         ##   ###      ##      
 ######    ########   ####  ########   ##    ##      ##      
*/

	$("select[name=js-client-statut]").change(function(){
		var element = $(this).closest('.ep-liste-clients--client');
		var url     = "/espace-prescripteur/dashboard/clients/";
		var value   = $(this).val();
		var data    = "act=envoi&id= " + element.data('id') + "&statut=" + value;
		$.ajax({
            type    : "POST",
            data    : data,
            url     : url,
            success : function(retour) {
            	try {
					retour = JSON.parse(retour);
					if( retour.error ){
						alert( retour.error );
					}else{
						// console.log(retour.on);
						element.toggleClass('ep-liste-clients--client--off', retour.off);
						element.attr('data-statut', value);
						// if( value != filter_statut.val() && filter_statut.val() !== "" ) element.hide();
						filterChange();
					}
				}catch(e){
                	alert(retour);
                }
            }
        });
	});

	$('.ep-dashboard-btn--view').on('click', function(e){
		e.preventDefault();

		var element       = $(this).closest('table').closest('tr');
		var elementDetail = $("#ep-liste-clients tbody > tr.ep-liste-clients--reservation[data-id="+element.data('id')+"]");
		
		if( element.hasClass('highlight') ){
			$("#ep-liste-clients tbody > tr").removeClass('down').removeClass('highlight');
			return false;
		}

		$("#ep-liste-clients tbody > tr").removeClass('down').removeClass('highlight');
		$("#ep-liste-clients tbody > tr[data-id!="+element.data('id')+"]").toggleClass('down');

		element.toggleClass('highlight');
		$.each(elementDetail, function(){
			// console.log( $(this).find('tr').length );
			if( $(this).find('tr').length > 1 ){
				$(this).toggleClass('highlight');
			}
		});

	});

	var filterChange = function(){
		$(".ep-liste-clients--name").each(function(){
			$(this).show();
			var cpt = 0;
			$.each( $(this).nextUntil('.ep-liste-clients--name'), function(){
				if( $(this).is(':visible') ) cpt++;
			});
			if( cpt == 0 ){
				$(this).hide();
			}
		});
	}
	var filter_name = $("select[name='filter_name']").select2({
		language:          "fr",
		placeholder:       'Nom du client',
		containerCssClass: 'select2_filter',
		allowClear:        true,
		minimumResultsForSearch: 10
	});

	/*
        filter_name.on('select2:select', function(e){
            var val = e.params.data.id;
            $("#ep-liste-clients > tbody tr[data-filter][data-name-id!='"+val+"']").hide();
            $("#ep-liste-clients > tbody tr[data-filter][data-name-id='"+val+"']").show();

            $(".ep-liste-clients--programme").each(function(){
                if( $(this).next('.ep-liste-clients--client:visible ').length == 0 ){
                    $(this).hide();
                }else{
                    $(this).show();
                }
            });

            filter_statut.val(null).trigger("change");
            filter_prescripteur.val(null).trigger("change");
            filterChange();
        });

        filter_name.on('select2:unselecting', function(e){
            $("#ep-liste-clients > tbody tr[data-filter]").show();
            $(".ep-liste-clients--name").show();
            $(".ep-liste-clients--programme").show();
        });
        */

        var filter_prescripteur = $("select[name='filter_prescripteur']").select2({
            language:          "fr",
            placeholder:       'Nom du prescripteur',
            containerCssClass: 'select2_filter',
            allowClear:        true,
            minimumResultsForSearch: 10
        });
    /*
        filter_prescripteur.on('select2:select', function(e){
            var val = e.params.data.id;
            // window.location.href = window.location.origin+"/espace-prescripteur/dashboard/clients/"+val+"/";
            $("#ep-liste-clients > tbody tr[data-filter][data-prescripteur!='"+val+"']").hide();
            $("#ep-liste-clients > tbody tr[data-filter][data-prescripteur='"+val+"']").show();
            filter_statut.val(null).trigger("change");
            filter_name.val(null).trigger("change");
            filterChange();
        });

        filter_prescripteur.on('select2:unselecting', function(e){
            $("#ep-liste-clients > tbody tr[data-filter]").show();
            $(".ep-liste-clients--name").show();
            filterChange();
            // window.location.href = window.location.origin+"/espace-prescripteur/dashboard/clients/";
        });
        */

        var filter_statut = $("select[name='filter_statut']").select2({
            language:                "fr",
            placeholder:             'Statut client',
            containerCssClass:       'select2_filter',
            allowClear:              true,
            minimumResultsForSearch: 10
        });
    /*
        filter_statut.on('select2:select', function(e){
            var val = e.params.data.id;
            var order = getUrlVars().order;
            if( order ) {
                window.location.href = window.location.origin + "/espace-prescripteur/dashboard/clients/statut/" + val + "/?order=" + order;
            }else{
                window.location.href = window.location.origin+"/espace-prescripteur/dashboard/clients/statut/"+val+"/";
            }
        });

        filter_statut.on('select2:unselecting', function(e){
            window.location.href = window.location.origin+"/espace-prescripteur/dashboard/clients/statut/";
        });
    */

	var filter_reservation = $("select[name='filter_reservation']").select2({
		language:          "fr",
		minimumResultsForSearch: 10
	});

	filter_reservation.on('select2:select', function(e){
		var val = e.params.data.id;
		// console.log(val);
		$('.ep-client-reservation__lot').closest('.ep-client-reservation-item').hide();
		$("."+val).closest('.ep-client-reservation-item').show();
	});

	filter_reservation.on('select2:unselecting', function(e){
		$('.ep-client-reservation-item').show();
	});

	$('.ep-btn--remove-child').on('click',function(e){
		e.preventDefault();
		$(this).next('input').val('true');
		$(this).closest('.ep-enfant').addClass('ep-enfant--remove');
	});

	// $('.item-ajax > div').matchHeight();

	$(".js-add-form").on('click', function(e){
		e.preventDefault();
		var url    = $(this).attr('href');
		var target = $(this).data('target');
		var data   = "act=ajax";

		var loader = $('<div class="item-ajax--loader">chargement en cours</div>');
		$("#"+target).append(loader);

		$.ajax({
            type    : "POST",
            data    : data,
            url     : url,
            success : function(retour) {
            	loader.remove();
                $("#"+target).append( retour );

				$("#"+target+" .item-ajax:last-of-type .datepicker").each(function() {

					$element = $(this);
					id = $element.attr('id').split("_");
					$element.attr("id", id[0] + "_" + $('.item-ajax').length );

					var element = $(this).prev('input');
					var name    = $(this).attr('name').substr(7);
					var max     = $(this).attr("max");
					var min     = $(this).attr("min");
					$(this).datepicker({
						dateFormat: "dd/mm/yy",
						altField: element,
						altFormat: "yy-mm-dd",
						dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
						monthNames: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
						monthNamesShort: ["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"],
						onClose: function( selectedDate ) {
							if(max) $("#"+max).datepicker("option", "minDate", selectedDate);
							if(min) $("#"+min).datepicker("option", "maxDate", selectedDate);
						}
					});
					
					if(max) $(this).datepicker("option", "maxDate", $("#"+max).val());
					if(min) $(this).datepicker("option", "minDate", $("#"+min).val());		
				});

                $.fn.matchHeight._apply(".item-ajax:not(.item-ajax--remove) > div");
            }
        });
	});

	$(document).on('click', '.js-remove-form', function(e){
		e.preventDefault();

		var element = $(this);
		var url     = $(this).attr('href');
		var data    = "act=remove";
		$.ajax({
            type    : "POST",
            data    : data,
            url     : url,
            success : function(retour) {
				element.closest('.item-ajax').remove();
				$.fn.matchHeight._apply(".item-ajax > div");
            }
        });
	});

	$('.ep-client-reservation__timeline__step').each(function(){
		var slider_step = $(this);
		slider_step.on('afterChange', function(event, slick, direction){
			// current = slick.currentSlide;
			// console.log( current );
			// slider_step.next('.ep-client-reservation__timeline__item').slick('slickGoTo', current);
		}).slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			infinite: false,
			arrows:false,
			swipe:false,
			swipeToSlide: false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
		$('.slick-slide', slider_step).on('click', function(){
			index = $(this).index();
			slider_step.find('.slick-current').removeClass('slick-current');
			$(this).addClass('slick-current');
			slider_step.next('.ep-client-reservation__timeline__item').slick('slickGoTo', index);
		});
	});

	$('.ep-client-reservation__timeline__item').each(function(){
		var slider_item = $(this);
		slider_item.on('init afterChange', function(event, slick, direction){
			current = slick.currentSlide;
			slider_item.prev('.ep-client-reservation__timeline__step').slick('slickGoTo', current);
			slider_item.prev('.ep-client-reservation__timeline__step').find('.slick-current').removeClass('slick-current');
			slider_item.prev('.ep-client-reservation__timeline__step').find('.slick-slide:eq( '+current+' )').addClass('slick-current');
		}).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			infinite: false,
			arrows:false,
			swipe:false,
			swipeToSlide: false,
			initialSlide : $(this).find('.ep-client-reservation__timeline__item--current').index()
		});	
	});

	$('.ep-fideliy-progress').slick({
		slidesToShow: 3,
		slidesToScroll: 3,
		infinite: false,
		prevArrow : $('.ep-fidelity-progress__nav--prev'),
		nextArrow : $('.ep-fidelity-progress__nav--next'),
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

/*
   ###      ######    ########   ####   #######   ##    ##   
  ## ##    ##    ##      ##       ##   ##     ##  ###   ##   
 ##   ##   ##            ##       ##   ##     ##  ####  ##   
##     ##  ##            ##       ##   ##     ##  ## ## ##   
#########  ##            ##       ##   ##     ##  ##  ####   
##     ##  ##    ##      ##       ##   ##     ##  ##   ###   
##     ##   ######       ##      ####   #######   ##    ##   
*/
/*
########   ########   ##    ##   
##     ##     ##      ###   ##   
##     ##     ##      ####  ##   
########      ##      ## ## ##   
##     ##     ##      ##  ####   
##     ##     ##      ##   ###   
########      ##      ##    ##   
*/

	$.magnificPopup.instance._onFocusIn = function(e) {
		if( $(e.target).hasClass('select2-search__field') ) {
			return true;
		}
		$.magnificPopup.proto._onFocusIn.call(this,e);
	};

	function initMagnificPopup(){

		$(".js-btn-modal").on('click', function(e){
			e.preventDefault();
			
			var url = $(this).attr('href');
			var data = 'act=envoi';
	        for(var i in $(this).data()){
	            data += "&"+i+"="+$(this).data(i);
	        }

			$.magnificPopup.open({
				items:{
					src : url
				},
				type: 'ajax',
				tLoading: 'chargement...',
				closeOnBgClick: false,
				ajax: {
					settings: {
						data: data,
						type: 'POST'
					}
				},
				callbacks: {
					ajaxContentAdded: function() {
						initForm();
						$('.ep-form-field').matchHeight();
					}
				}

			});
		});

	}

	initMagnificPopup();

	var insertViaAjax = function( url, target ){

		var loader = $('<div class="item-ajax--loader">chargement en cours</div>');
		$("#"+target).append(loader);

		$.ajax({
            type    : "POST",
            url     : url,
            success : function(retour) {
            	loader.remove();
                $("#"+target).prepend( retour );
                initForm();
                $.magnificPopup.proto.close.call(this);
            }
        });

	}

	$(".ep-btn--inactive").unbind('click').on('click', function(e){
		e.preventDefault();
	});

/*
 ######    ##     ##     ###     ########   ########    ######    
##    ##   ##     ##    ## ##    ##     ##     ##      ##    ##   
##         ##     ##   ##   ##   ##     ##     ##      ##         
##         #########  ##     ##  ########      ##       ######    
##         ##     ##  #########  ##   ##       ##            ##   
##    ##   ##     ##  ##     ##  ##    ##      ##      ##    ##   
 ######    ##     ##  ##     ##  ##     ##     ##       ######    
*/

	submitFormStats = function( form, charts ){

        var url  = form.attr('action');

        formData   = new FormData();
        formParams = form.serializeArray();
        formData.append("ajax", "charts");

		$.each(formParams, function(i, val) {
			formData.append(val.name, val.value);
		});

		form.find('.ep-stats tbody, .ep-stats tfoot').empty();
		tr = '<tr><td colspan="4">chargement...</td></tr>';
		form.find('.ep-stats tbody').append( tr );

        $.ajax({
            type    : "POST",
            data    : formData,
            url     : url,
            processData: false,
			contentType: false,
            success : function(retour) {
            	try {
					data = $.parseJSON(retour);

					if( charts ){

						var point = [];
						var axis  = [];
						$.each( data.pie, function(e, value){
							point.push( value[1][0] );
							axis.push( value[0] );
						});

						var chartGraph = $('#'+charts).highcharts({
							chart: {
								type: data.type,
								height: 800
							},
							title: {
								text: data.title
							},
							subtitle: {
						        text: data.legend
						    },
							xAxis: {
								categories: axis,
								type: 'category',
								offset: 10,
								labels: {
									step: 1,
									distance: '20',
								},
							},
							legend: {
								enabled: false
							},
							yAxis: {
								min: 0,
								// tickInterval: 1,
								title: {
									text: 'Nb'
								},
								stackLabels: {
									enabled: true,
									style: {
										fontWeight: 'bold',
										color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
									}
								}
							},
							tooltip: {
								pointFormat: '<b>{point.y}</b>'
							},
							plotOptions: {
								bar: {
									dataLabels: {
										enabled: true
									}
								}
							},
							series : [{
								name: false,
								data : point
							}]
						});

					}

					// affichage du tableau résultant de la recherche
					if( data.pie ){

						var date  = null;
						var total = {};

						form.find('.ep-stats tbody, .ep-stats tfoot').empty();
						
						$.each( data.pie, function(e, value){
							tr = '<tr><td>'+ value[0] + '</td>';
							$.each( value[1], function(index, val){
								tr += '<td>'+ val +'</td>';
								if( total[index] ){
									total[index] = parseInt(total[index]) + parseInt(val);
								}else{
									total[index] = parseInt(val);
								}
							});
							tr += '</tr>';
							form.find('.ep-stats tbody').append( tr );
						});

						// tr = '<tr><th>Total</th><td>'+ total +'</td></tr>';
						tr = '<tr><th>Total</th>';
						$.each( total, function(index, val){
							tr += '<td>'+ val +'</td>';
						});
						tr += '</tr>';
						form.find('.ep-stats tfoot').append( tr );

					}else{

						form.find('.ep-stats tbody, .ep-stats tfoot').empty();
						tr = '<tr><td colspan="4">Aucun résutat</td></tr>';
						form.find('.ep-stats tbody').append( tr );

					}

					if( data.client ){
						var html = "";
						$.each( data.client, function(e, client){
							html += client.nom + "<br>";
						});
						$('#clientContainer').html( html );
					}

				}catch(e){

					form.find('.ep-stats tbody, .ep-stats tfoot').empty();
					tr = '<tr><td colspan="4">erreur</td></tr>';
					form.find('.ep-stats tbody').append( tr );

                }
            }
        });
	}

	$(".ep-form--stats").each(function(){
		submitFormStats( $(this), $(this).data('charts') );
	});

});
